import React, { type ReactNode } from 'react';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';

type Props = {
	children: ReactNode;
	projectKey: string;
};

export const ProjectAppContainer = ({ children, projectKey }: Props) => (
	<ProjectContextProvider>
		{({ data: projectData }) => (
			<ProjectBreadcrumb
				projectKey={projectKey}
				projectName={projectData ? projectData.projectName : ''}
			>
				{children}
			</ProjectBreadcrumb>
		)}
	</ProjectContextProvider>
);
